import moment from 'moment';

import { getCompletedPatientOncehubBookingsByNeurologist } from 'common-src/models/PatientOncehubBooking';
import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientReferrals = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientReferral',
    (referral) => referral.patientId === patientId && !referral.deletedAt,
  );

export const getFilteredPatientReferrals = (state, patientId) => {
  const patientReferrals = getPatientReferrals(state, patientId);
  const neurologistVisits = getCompletedPatientOncehubBookingsByNeurologist(state, patientId);
  const lastVisit = neurologistVisits[0];
  const beforeLastVisit = neurologistVisits[1];

  if (!lastVisit || !beforeLastVisit) return patientReferrals;

  return patientReferrals.filter(
    (referral) =>
      moment(referral.updatedAt).isAfter(moment(beforeLastVisit.scheduledAt)) &&
      moment(referral.updatedAt).isBefore(moment(lastVisit.scheduledAt)),
  );
};
